export function disableChat() {
  const messageInput = /** @type {HTMLFormElement | null} */ (
    document.getElementById('message-input')
  )
  if (messageInput) {
    messageInput.disabled = true
  }

  const sendButton = /** @type {HTMLFormElement | null} */ (
    document.getElementById('send-button')
  )
  if (sendButton) {
    sendButton.disabled = true
  }
}
